// Touch devices report `(hover: none)` and synthesize a `mouseenter` event on
// tap, which pops hover-only tooltips that have no valid trigger on mobile.
// Gate on hover *capability*, not viewport width — a narrow desktop window can
// still hover and should keep its tooltips.
export function canHover(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return true; // fail open: preserve desktop hover behavior when undetectable
  }
  // Require a hover-capable AND fine (mouse/trackpad) primary pointer. The
  // `(pointer: fine)` clause excludes touch devices — notably Samsung/Chromium
  // Android, which falsely report `(hover: hover)` — that would otherwise still
  // pop tooltips on tap. Not `(any-hover: hover)`, which would match touch-primary
  // hybrids that merely have a mouse attached.
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
